<template>
  <div>
    <a-card :bordered="false">
      <div class="x-tool">
        <a-button type="primary" icon="plus" @click="add" v-has="'/system/roleAdd'">新增</a-button>
      </div>

      <a-table
        :rowKey="record => record.id"
        :columns="tableColumns"
        :dataSource="tableData"
        :loading="tableLoading"
        :pagination="false"
      >
          <span slot="action" slot-scope="record">
            <template>
              <a @click="update(record)" v-has="'/system/roleUpdate'">修改</a>
              <a-divider type="vertical" />
              <a-popconfirm placement="topRight" title="你确定要删除该角色?" @confirm="del(record.id)">
                <a href="#" v-has="'/system/roleDel'">删除</a>
              </a-popconfirm>
            </template>
          </span>
      </a-table>

      <div class="x-pagination">
        <a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
                      :hideOnSinglePage="true" show-less-items />
      </div>

      <role-form-modal
        ref="roleFormModal"
        :visible="formVisible"
        :loading="formLoading"
        @cancel="formCancel"
        @ok="formOk"
      />
    </a-card>
  </div>
</template>

<script>
import RoleFormModal from "@/pages/system/role/RoleFormModal.vue";
import { roleList, roleAdd, roleUpdate, roleDel, roleFuncList } from '@/api/system/role';

const tableColumns = [
  {
    title: '#',
    dataIndex: 'id',
  },
  {
    title: '名称',
    dataIndex: 'name',
  },
  {
    title: '创建时间',
    dataIndex: 'created',
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' }
  },
];

export default {
    components: {
        RoleFormModal
    },
    data() {
        return {
            formVisible: false,
            formLoading: false,
            tableColumns,
            tableData: [],
            tableLoading: false,
            totalRow: 0,
            pageSize: 20,
            pageIndex: 1
        }
    },
    created() {
        this.fetchTableData();
    },
    methods: {
        fetchTableData() {
            this.tableLoading = true;
            return roleList().then(res => {
                this.totalRow = res.data.totalRow;
                this.tableData = res.data.recordList;
                this.tableLoading = false;
            });
        },
        pageChange(current) {
            this.pageIndex = current;
            this.fetchTableData();
        },
        add() {
            this.formVisible = true;
            this.$refs.roleFormModal.initForm();
        },
        update(record) {
            this.formLoading = true;
            this.formVisible = true;
            roleFuncList(record.id).then(res => {
                this.formLoading = false;
                record.funcIds = res.data.funcIds;
				record.halfIds = res.data.halfIds;
                this.$refs.roleFormModal.form = { ...record }
            });
        },
        del(id) {
            roleDel(id).then(() => {
                this.$message.success('删除角色成功');
                this.fetchTableData();
            });
        },
        formOk () {
            this.$refs.roleFormModal.$refs['roleForm'].validate(valid=>{
                if(valid) {
                    this.formLoading = true;
                    const formData = this.$refs.roleFormModal.form;
                    if (formData.id > 0) {
                        roleUpdate(formData).then(() => {
                            this.formAfter('修改角色成功');
                        });
                    } else {
                        roleAdd(formData).then(() => {
                            this.formAfter('新增角色成功');
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        formCancel () {
            this.formVisible = false;
        },
        formAfter(message) {
            this.formVisible = false;
            this.formLoading = false;
            // 刷新表格
            this.fetchTableData();
            this.$message.success(message);
        }
    }
}
</script>

<style scoped>

</style>